const getSideBarTitleMessageId = ({ pricingErrorCode }: { pricingErrorCode: number | null }): string => {
    return !pricingErrorCode ? 'selectDatesAndGuests' : 'notAvailable'
}

export default getSideBarTitleMessageId
